<div id="main-container">
    <div id="loading-indicator-container" *ngIf="showLoadingIndicator">
        <img src="/assets/loading-indicator-4-dark.svg">
    </div>

    <iframe id="proxied-container" src=""></iframe>

    <app-help-dialog *ngIf="(modalActive && modalName=='help-dialog')"></app-help-dialog>
</div>